<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="shrink-0" :class="$attrs.class">
    <circle cx="12" cy="18" r="4" />
    <path d="M12 14V6M12 6l-3 3M12 6l3 3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup>defineOptions({ inheritAttrs: false });</script>
